import { isArabicString, isDefinedArray } from "et3-type-guards";
import { MAXIMUM_PROMOCODE_CHARACTERS } from "../constants/input-entries-constants";
import { StringOrNumber } from "../Types";

export const et3ReadableDecimalNumber = (
  data: number,
  numberOfDecimals: number
) => {
  const decimalNumbers = parseFloat(`1e${numberOfDecimals}`);
  return Math.round(data * decimalNumbers) / decimalNumbers;
};

export const getEducationById = (id: number) => {
  switch (id) {
    case 1:
      return "تعليم أساسي,	Less than High School,	Collège";
    case 2:
      return "تعليم متوسط/ معهد,	High School,	Lycée";
    case 3:
      return "شهادة جامعية ,	Bachelor,	License";
    case 5:
      return "ماجستير ,	Master,	Master";
    case 6:
      return "دكتوراه ,	PHD,	Doctorat";
    default:
      return "";
  }
};
export const getWorkById = (id: number) => {
  switch (id) {
    case 1:
      return " طالب ,	A student,	Étudiant";
    case 2:
      return " موظف ,	An employee,	Employé";
    case 7:
      return "موظف برتبة, عالية,	A senior employee,	Employé Senior";
    case 3:
      return " مدير,	A manager / director,	Manager / Directeur";
    case 4:
      return "عاطل عن العمل,	Unemployed,	Sans emploi";
    case 5:
      return " متقاعد,	Retired	,Retraité";
    case -1:
      return " أفضل عدم الإجابة,	I prefer not to answer	,Je préfère ne pas répondre";
    default:
      return id;
  }
};

export const getMartialStatusByKeyForFemale = (value: string) => {
  switch (value) {
    case "single":
      return "أعزب, Single, Célibataire";
    case "divorce":
      return "مطلق من دون أطفال, Divorced without kids,  Divorcé sans enfants";
    case "divorce_with_children":
      return "مطلق مع أطفال, Divorced with kids, Divorcé avec enfant(s)";
    case "widower":
      return "أرمل من دون أطفال , Widower without kids ,Veuf sans enfants";
    case "widower_with_children":
      return "أرمل مع أطفال ,Widower with kid(s) ,Veuf avec enfant(s)";
    default:
      return "";
  }
};
export const getMartialStatusByKeyForMale = (value: string) => {
  switch (value) {
    case "single":
      return "أعزب, Single, Célibataire";
    case "divorce":
      return "مطلق من دون أطفال, Divorced without kids,  Divorcé sans enfants";
    case "divorce_with_children":
      return "مطلق مع أطفال, Divorced with kids, Divorcé avec enfant(s)";
    case "widower":
      return "أرمل من دون أطفال , Widower without kids ,Veuf sans enfants";
    case "widower_with_children":
      return "أرمل مع أطفال ,Widower with kid(s) ,Veuf avec enfant(s)";
    case "married":
      return "متزوج Married Marié";
    default:
      return "";
  }
};
export const getCountryByKey = (value: string) => {
  switch (value) {
    case "AD":
      return "أندورا, Andorra, Andorre";
    case "AE":
      return "الإمارات العربية المتحدة, United Arab Emirates, Émirats Arabes Unis";
    case "AF":
      return "أفغانستان, Afghanistan, Afghanistan";
    case "AG":
      return "أنتيغوا وبربودا, Antigua And Barbuda, Antigua-et-Barbuda";
    case "AI":
      return "أنغويلا, Anguilla, Anguilla";
    case "AL":
      return "ألبانيا, Albania, Albanie";

    case "AM":
      return "أرمينيا, Armenia, Arménie";
    case "AO":
      return "أنغولا, Angola, Angola";
    case "AQ":
      return "أنتاركتيكا, Antarctica, Antarctique";
    case "AR":
      return "الأرجنتين, Argentina, Argentine";
    case "AS":
      return "ساموا-الأمريكي, American Samoa, Samoa américaines";
    case "AT":
      return "النمسا, Austria, L'Autriche";

    case "AU":
      return "أستراليا, Australia, Australie";
    case "AW":
      return "أروبا, Aruba, Aruba";
    case "AZ":
      return "أذربيجان ,Azerbaijan ,Azerbaïdjan";
    case "BA":
      return "البوسنة و الهرسك, Bosnia And Herzegovina, La Bosnie-Herzégovine";
    case "BB":
      return "بربادوس, Barbados, Barbade";
    case "BD":
      return "بنغلاديش, Bangladesh, Bangladesh";
    case "BE":
      return "بلجيكا, Belgium, Belgique";
    case "BF":
      return "بوركينا فاسو, Burkina Faso, Burkina Faso";
    case "BG":
      return "بلغاريا, Bulgaria, Bulgarie";
    case "BH":
      return "البحرين, Bahrain, Bahreïn";
    case "BI":
      return "بوروندي, Burundi, Burundi";
    case "BJ":
      return "بنين, Benin, Bénin";
    case "BM":
      return "جزر برمود, Bermuda, Iles des Bermudes";
    case "BN":
      return "بروناي, Brunei, Brunei";
    case "BO":
      return "بوليفيا, Bolivia, Bolivie";
    case "BR":
      return "البرازيل, Brazil, Brésil";
    case "BS":
      return "الباهاماس, Bahamas, Bahamas";
    case "BT":
      return "بوتان, Bhutan, Bhoutan";
    case "BW":
      return "بوتسوانا, Botswana, Botswana";
    case "BY":
      return "روسيا البيضاء, Belarus, Biélorussie";
    case "BZ":
      return "بيليز, Belize, Belize";
    case "CA":
      return "كندا, Canada, Canada";
    case "CD":
      return "جمهورية الكونغو الديمقراطية, Democratic Republic of Congo, République Démocratique du Congo";
    case "CF":
      return "جمهورية أفريقيا الوسطى, Central African Republic, République centrafricaine";
    case "CG":
      return "الكونغو, Congo, Congo";
    case "CH":
      return "سويسرا, Switzerland, Suisse";
    case "CI":
      return "ساحل العاج, Ivory Coast, Côte d'Ivoire";
    case "CK":
      return "جزر كوك, Cook Islands, Îles Cook";
    case "CL":
      return "تشيلي, Chile, Chili";
    case "CM":
      return "كاميرون, Cameroon, Cameron";
    case "CN":
      return "صين, China, Chine";
    case "CO":
      return "كولومبيا, Colombia, Colombie";

    case "CR":
      return "كوستاريكا, Costa Rica, Costa Rica";
    case "CU":
      return "كوبا, Cuba, Cuba";
    case "CV":
      return "الرأس الأخضر, Cape Verde, Cape Verde";
    case "CY":
      return "قبرص, Cyprus, Chypre";
    case "CZ":
      return "الجمهورية التشيكية, Czech Republic, République Tchèque";
    case "DE":
      return "ألمانيا, Germany, Allemagne";
    case "DJ":
      return "جيبوتي, Djibouti, Djibouti";
    case "DK":
      return "الدانمارك, Denmark, Danemark";
    case "DM":
      return "دومينيكا, Dominica, Dominique";
    case "DO":
      return "الجمهورية الدومينيكية, Dominican Republic, République Dominicaine";

    case "DZ":
      return "الجزائر, Algeria, Algérie";
    case "EC":
      return "إكوادور, Ecuador, Equateur";
    case "EE":
      return "استونيا, Estonia, Estonie";
    case "EG":
      return "مصر, Egypt, Egypte";
    case "EH":
      return "الصحراء الغربية, Western Sahara, Sahara occidentale";
    case "ER":
      return "إريتريا, Eritrea, Érythrée";
    case "ES":
      return "إسبانيا, Spain, Espagne";
    case "ET":
      return "أثيوبيا, Ethiopia, Ethiopie";
    case "FI":
      return "فنلندا, Finland, Finlande";
    case "FJ":
      return "فيجي, Fiji, Fidji";
    case "FO":
      return "جزر فارو, Faroe Islands, Îles Féroé";
    case "GA":
      return "الغابون, Gabon, Gabon";
    case "GB":
      return "المملكة المتحدة, United Kingdom, Royaume-Uni";
    case "GD":
      return "غرينادا, Grenada, Grenade";
    case "GE":
      return "جيورجيا, Georgia, Géorgie";
    case "GF":
      return "غويانا الفرنسية, French Guiana, Guyane Française";
    case "GH":
      return "غانا, Ghana, Ghana";
    case "GL":
      return "جرينلاند, Greenland, Greenland";
    case "GM":
      return "غامبيا, Gambia, Gambie";
    case "GN":
      return "غينيا, Guinea, Guinée";
    case "GP":
      return "جوادلوب, Guadeloupe, Guadeloupe";
    case "GQ":
      return "غينيا الاستوائية, Equatorial Guinea, Guinée Équatoriale";
    case "GR":
      return "اليونان, Greece, Grèce";
    case "GT":
      return "غواتيمال, Guatemala, Guatemala";
    case "GU":
      return "جوام, Guam, Guam";
    case "GW":
      return "غينيا-بيساو, Guinea-Bissau, Guinée-Bissau";
    case "GY":
      return "غيانا, Guyana, Guyane";
    case "HK":
      return "هونغ كونغ, Hong Kong, Hong Kong";
    case "HN":
      return "هندوراس, Honduras, Honduras";
    case "HR":
      return "كرواتيا, Croatia, Croatie";
    case "HT":
      return "هايتي, Haiti, Haïti";
    case "HU":
      return "المجر, Hungary, Hongrie";
    case "ID":
      return "أندونيسيا, Indonesia, Indonésie";
    case "IE":
      return "أيرلندا, Ireland, Irlande";
    case "PS":
      return "فلسطين, Palestine, Palestine";
    case "IN":
      return "الهند, India, Inde";
    case "IQ":
      return "العراق, Iraq, Irak";
    case "IR":
      return "إيران, Iran, Iran";
    case "IS":
      return "آيسلندا, Iceland, Islande";
    case "IT":
      return "إيطاليا, Italy, Italie";
    case "JM":
      return "جمايكا, Jamaica, Jamaïque";
    case "JO":
      return "الأردن, Jordan, Jordan";
    case "JP":
      return "اليابان, Japan, Japon";
    case "KE":
      return "كينيا, Kenya, Kenya";
    case "KG":
      return "قيرغيزستان, Kyrgyzstan, Kirghizistan";
    case "KH":
      return "كمبوديا, Cambodia, Cambodge";
    case "KI":
      return "كيريباتي, Kiribati, Kiribati";
    case "KN":
      return "سانت كيتس ونيفس, Saint Kitts And Nevis, Saint-Christophe-et-Niévès";
    case "KP":
      return "كوريا الشماليه, North Korea, Corée du Nord";
    case "KR":
      return "كوريا الجنوبية, South Korea, Corée du Sud";
    case "KW":
      return "الكويت, Kuwait, Koweit";
    case "KY":
      return "جزر كايمان, Cayman Islands, Îles Caïmans";
    case "KZ":
      return "كازاخستان, Kazakhstan, Kazakhstan";
    case "LA":
      return "لاوس, Laos, Laos";
    case "LB":
      return "لبنان, Lebanon, Liban";
    case "LC":
      return "سانت لوسيا, Saint Lucia, Sainte-Lucie";
    case "LI":
      return "ليختنشتين, Liechtenstein, Liechtenstein";
    case "LK":
      return "سريلانكا, Sri Lanka, Sri Lanka";
    case "LR":
      return "ليبيريا, Liberia, Libéria";
    case "LS":
      return "ليسوتو, Lesotho, Lesotho";
    case "LT":
      return "لتوانيا, Lithuania, Lituanie";
    case "LU":
      return "لوكسمبورغ, Luxembourg, Luxembourg";
    case "LV":
      return "لاتفيا, Latvia, Lettonie";
    case "LY":
      return "ليبيا, Libya, Libye";
    case "MA":
      return "المغرب, Morocco, Maroc";
    case "MC":
      return "موناكو, Monaco, Monaco";
    case "MD":
      return "مولدافيا, Moldova, Moldavie";
    case "ME":
      return "الجبل الأسو, Montenegro, Montenegro";
    case "MG":
      return "مدغشقر, Madagascar, Madagascar";
    case "MH":
      return "جزر مارشال, Marshall Islands, Iles Marshall";
    case "MK":
      return "مقدونيا, Macedonia, Macédoine";
    case "ML":
      return "مالي, Mali, Mali";
    case "MM":
      return "ميانمار, Myanmar, Myanmar";
    case "MN":
      return "منغوليا, Mongolia, Mongolie";
    case "MO":
      return "ماكاو, Macao, Macao";
    case "MP":
      return "جزر ماريانا الشمالية, Northern Mariana Islands, Îles Mariannes du Nord";
    case "MQ":
      return "مارتينيك, Martinique, Martinique";
    case "MR":
      return "موريتانيا, Mauritania, Mauritanie";
    case "MS":
      return "مونتسيرات, Montserrat, Montserrat";
    case "MT":
      return "مالطا, Malta, Malte";
    case "MU":
      return "موريشيوس, Mauritius, Ile Maurice";
    case "MV":
      return "المالديف, Maldives, Maldives";
    case "MW":
      return "مالاوي, Malawi, Malawi";
    case "MX":
      return "المكسيك, Mexico, Mexique";
    case "MY":
      return "ماليزيا, Malaysia, Malaisie";
    case "MZ":
      return "موزمبيق, Mozambique, Mozambique";
    case "NA":
      return "ناميبيا, Namibia, Namibie";
    case "NC":
      return "كاليدونيا الجديدة, New Caledonia, Nouvelle Calédonie";
    case "NE":
      return "النيجر, Niger, Niger";
    case "NG":
      return "نيجيريا, Nigeria, Nigeria";

    case "NI":
      return "نيكاراجوا, Nicaragua, Nicaragua";
    case "NL":
      return "هولندا, Netherlands, Hollande";
    case "NO":
      return "النرويج, Norway, Norvège";
    case "NP":
      return "نيبال, Nepal, Népal";
    case "NR":
      return "ناورو, Nauru, Nauru";
    case "NU":
      return "نييوي, Niue, Niue";
    case "NZ":
      return "نيوزيلندا, New Zealand, Nouvelle-Zélande";
    case "OM":
      return "عمان, Oman, Oman";
    case "PA":
      return "بنما, Panama, Panama";
    case "PE":
      return "بيرو, Peru, Pérou";
    case "PF":
      return "بولينيزيا الفرنسية, French Polynesia, Polynésie française";
    case "PG":
      return "بابوا غينيا الجديدة, Papua New Guinea, Papouasie Nouvelle Guinée";
    case "PH":
      return "الفليبين, Philippines, Philippines";
    case "PK":
      return "باكستان, Pakistan, Pakistan";
    case "PL":
      return "بولندا, Poland, Pologne";
    case "PR":
      return "بورتوريكو, Puerto Rico, Porto Rico";
    case "PT":
      return "البرتغال, Portugal, le Portugal";
    case "PW":
      return "بالاو, Palau, Palau";
    case "PY":
      return "باراغواي, Paraguay, Paraguay";
    case "QA":
      return "قطر, Qatar, Qatar";
    case "RO":
      return "رومانيا, Romania, Roumanie";
    case "RS":
      return "جمهورية صربيا, Serbia, République de Serbie";
    case "RU":
      return "روسيا, Russian Federation, Russie";
    case "RW":
      return "رواندا, Rwanda, Rwanda";

    case "SA":
      return "المملكة العربية السعودية, Saudi Arabia, Arabie Saoudite";
    case "SB":
      return "جزر سليمان, Solomon Islands, îles Salomon";
    case "SC":
      return "سيشيل, Seychelles, Seychelles";
    case "SD":
      return "السودان, Sudan, Soudan";
    case "SE":
      return "السويد, Sweden, Suède";
    case "SG":
      return "سنغافورة, Singapore, Singapour";
    case "SI":
      return "سلوفينيا, Slovenia, Slovénie";
    case "SK":
      return "سلوفاكيا, Slovakia, Slovaquie";
    case "SL":
      return "سيراليون, Sierra Leone, Sierra Leone";
    case "SM":
      return "سان مارينو, San Marino, Saint Marin";
    case "SN":
      return "السنغال,Senegal ,Sénégal";
    case "SO":
      return "الصومال,Somalia ,Somalie";
    case "SR":
      return "سورينام,Suriname ,Suriname";
    case "SV":
      return "إلسلفادور,El Salvador, Salvador ";
    case "SY":
      return "سوريا,Syria ,Syrie";
    case "SZ":
      return "سوازيلند,Swaziland ,Swaziland";
    case "TD":
      return "تشاد, Chad ,Tchad ";
    case "TG":
      return "توغو,Togo ,Togo";
    case "TH":
      return "تايلندا ,Thailand, Thaïlande";
    case "TJ":
      return "طاجيكستان,Tajikistan ,Tadjikistan";
    case "TM":
      return "تركمانستان ,Turkmenistan, Turkménistan";
    case "TN":
      return "تونس,Tunisia ,Tunisie";
    case "TO":
      return "تونغا,Tonga ,Tonga";
    case "TR":
      return "تركيا,Turkey ,Turquie";
    case "TT":
      return "ترينيداد وتوباغو,Trinidad And Tobago ,Trinité-et-Tobago";
    case "TV":
      return "توفالو,Tuvalu ,Tuvalu";
    case "TZ":
      return "تنزانيا,Tanzania ,Tanzanie";
    case "UA":
      return "أوكرانيا,Ukraine ,Ukraine";
    case "UG":
      return "أوغندا,Uganda ,Ouganda";
    case "US":
      return "الولايات المتحدة,United States ,États-Unis";
    case "UY":
      return "أورغواي,Uruguay,Uruguay";
    case "UZ":
      return "أوزباكستان,Uzbekistan ,Ouzbékistan";
    case "VC":
      return "سانت فنسنت وجزر غرينادين ,Saint Vincent And The Grenadines ,Saint-Vincent-et-les-Grenadines";

    case "VE":
      return "فنزويلا ,Venezuela ,Venezuela";
    case "VN":
      return "فيتنام ,Vietnam ,Vietnam";
    case "VU":
      return "فانواتو,Vanuatu,Vanuatu";
    case "WS":
      return "ساموا, Samoa, Samoa";

    case "YE":
      return "اليمن,Yemen ,Yemen";
    case "ZA":
      return "جنوب أفريقيا , South Africa ,Afrique du Sud";
    case "ZW":
      return " زامبيا , Zambia ,Zambie";
    case "VA":
      return "الفاتيكان, Vatican ,Vatican";
    case "FR":
      return "فرنسا, France ,France,";
    default:
      return "";
  }
};
export const isValidPassword = (password: string) => {
  try {
    const hasLetters = /[a-z]/i.test(password);
    const hasNumber = /\d/.test(password);
    const minLengthValid = password.length > 5;
    const maxLengthValid = password.length < 20;
    const hasArabic = /[\u0600-\u06FF\u0750-\u077F]/.test(password);

    const isValid =
      hasLetters && hasNumber && minLengthValid && maxLengthValid && !hasArabic;
    return isValid;
  } catch (err) {
    return false;
  }
};

export const isValidReferralOrPromoCodeCode = (
  valueToBeChecked: StringOrNumber
) => {
  const referralCodeValue = `${valueToBeChecked}`;
  const isCorrectlength =
    referralCodeValue.length <= MAXIMUM_PROMOCODE_CHARACTERS;
  const isCorrectFormat = /^$|^[A-Za-z0-9]+$/.test(referralCodeValue);
  const hasArabic = isArabicString(valueToBeChecked);
  return isCorrectlength && isCorrectFormat && !hasArabic;
};

export const customIntersectWithPriority = (
  arrays: number[][],
  priorityOrder: number[]
): number[] => {
  if (arrays.length === 0) return [];

  // Create a Set of common elements by iterating through all arrays
  const commonElements = arrays.reduce((acc, curr) => {
    const currentSet = new Set(curr);
    return acc.filter((item) => currentSet.has(item));
  }, arrays[0]);

  // Return without reordering if priorityOrder is not defined or empty
  if (!isDefinedArray(priorityOrder)) {
    return commonElements;
  }

  // Preserve order based on priorityOrder
  return priorityOrder.filter((item) => commonElements.includes(item));
};
